export default "__VITE_ASSET__mw46_GJ___"